import { createActionConfig } from './create-action-config';

export const type = '@appcues/request-push';
export const getRequestPush = () =>
  createActionConfig({
    type,
  });
